import { useRouter } from 'next/router';
import { ComponentProps, FC } from 'react';
import Turnstile, { useTurnstile } from 'react-turnstile';

const SITE_KEY = process.env.NEXT_PUBLIC_CLOUDFLARE_TURNSTILE_SITE_KEY;

export const CaftaTurnstile: FC<
  Omit<ComponentProps<typeof Turnstile>, 'sitekey'>
> = (props) => {
  useTurnstile();
  const { locale } = useRouter();

  return (
    <Turnstile
      language={locale}
      refreshExpired="auto"
      sitekey={SITE_KEY}
      {...props}
    />
  );
};
